import React from "react";
import { motion } from "framer-motion";
import { MANIFESTO } from "@/data";
import { IMAGES } from "@/data";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Manifesto = () => (
  <section id="ethos" data-testid="ethos" className="relative overflow-hidden bg-background px-6 py-24 md:px-12 md:py-32">
    <div className="glow-teal right-1/4 top-10 h-[360px] w-[360px] bg-cyan-500/12" />
    <div className="relative mx-auto grid max-w-[1500px] grid-cols-1 gap-16 md:grid-cols-12">
      <div className="md:col-span-4">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={reveal}
          className="sticky top-32"
        >
          <span className="font-mono-x text-xs uppercase tracking-[0.3em] text-primary">/ The Ethos</span>
          <h2 className="mt-6 font-cabinet text-4xl font-black uppercase leading-none tracking-tighter md:text-5xl">
            <span className="gradient-text">Honest, hands-on detailing — no gimmicks.</span>
          </h2>
          <div className="mt-10 gradient-fill p-[2px]">
            <div className="overflow-hidden bg-black">
              <motion.img
                whileInView={{ scale: 1 }}
                initial={{ scale: 1.2 }}
                transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
                viewport={{ once: true }}
                src={IMAGES.polish}
                alt="Detailer brushing an interior surface"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
          </div>
        </motion.div>
      </div>

      <div className="flex flex-col gap-px md:col-span-8">
        {MANIFESTO.map((m, i) => (
          <motion.div
            key={m.n}
            custom={i}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-60px" }}
            variants={reveal}
            data-testid={`ethos-item-${m.n}`}
            className="group relative border-t border-white/10 py-12 first:border-t-0 md:py-16"
          >
            <span className="pointer-events-none absolute -top-4 right-0 font-cabinet text-[7rem] font-black leading-none gradient-text opacity-20 md:text-[10rem]">
              {m.n}
            </span>
            <div className="relative max-w-xl">
              <h3 className="font-cabinet text-3xl font-bold uppercase tracking-tight text-white transition-colors duration-300 group-hover:text-primary md:text-4xl">
                {m.title}
              </h3>
              <p className="mt-5 text-lg leading-relaxed text-zinc-400">{m.body}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
